import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GbNotFoundComponent } from './gb-not-found/gb-not-found.component'
import { RouterModule, Routes } from '@angular/router'

import { TranslateModule } from '@ngx-translate/core'
import { MatButtonModule } from '@angular/material/button'
import { FormsModule } from '@angular/forms'
import { SharedUiModule } from 'libs/shared/ui/src/lib/shared-ui.module'
import { GbPageNotFoundComponent } from './gb-page-not-found/gb-page-not-found.component'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

export class NotFoundConstants {
  public static NOT_FOUND: string = 'not-found'
  public static PAGE_NOT_FOUND: string = 'page-not-found'
}

const routes: Routes = [
  {
    path: '',
    component: GbNotFoundComponent,
  },
]

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatProgressSpinnerModule,
    TranslateModule,
    MatButtonModule,
    FormsModule,
    SharedUiModule,
  ],
  declarations: [GbNotFoundComponent, GbPageNotFoundComponent],
})
export class GbFrontNotFoundFeatureModule {}
